export default "__VITE_ASSET__Cw_sp5M5__"